import React from "react";
import { formatCurrency } from "../../../../utilities/general";

export const shouldShowSalesTax = (invoiceData) => {
  const hasCalculatedTax = Number(invoiceData?.total_tax || 0) !== 0;
  const hasAppliedTaxRate = invoiceData?.pos_invoice_items?.some(
    (item) => Number(item.tax_rate_percentage || 0) > 0,
  );

  return hasCalculatedTax || hasAppliedTaxRate;
};

export const shouldShowAdditionalTaxes = (invoiceData) => {
  const groupedTaxes = invoiceData?.grouped_custom_taxes || {};
  const hasCustomTaxes = Boolean(Object.values(groupedTaxes)?.flat().length);

  return hasCustomTaxes || shouldShowSalesTax(invoiceData);
};

const AdditionalTaxes = ({ taxes, totalTax, showSalesTax }) => {
  const surcharges = taxes.surcharges || [];
  const preTaxes = taxes.pre_taxes || [];
  const postTaxes = taxes.post_taxes || [];

  return (
    <table
      border={0}
      cellPadding={10}
      cellSpacing={0}
      width={700}
      style={{ marginTop: "25px" }}
    >
      <tbody>
        <tr>
          <td
            style={{
              borderBottom: "1px solid #dddddd",
            }}
          >
            <div
              style={{
                fontSize: "13px",
                color: "#000000",
                textTransform: "uppercase",
                padding: "10px 0px",
              }}
            >
              ADDITIONAL CHARGES AND TAXES
            </div>
          </td>
          <td
            style={{
              borderBottom: "1px solid #dddddd",
            }}
            align="right"
          >
            <div
              style={{
                fontSize: "13px",
                color: "#000000",
                textTransform: "uppercase",
                textAlign: "right",
                padding: "10px 0px",
              }}
            >
              Amount
            </div>
          </td>
        </tr>
        {surcharges.map((tax) => (
          <tr key={tax.tax_id}>
            <td
              style={{
                borderBottom: "1px solid #dddddd",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#777777",
                  padding: "10px 0px",
                }}
              >
                {tax.custom_tax_name}{" "}
                {tax.custom_tax_percentage
                  ? ` (${Number(
                      parseFloat(tax.custom_tax_percentage).toFixed(2),
                    )}%)`
                  : ""}
              </div>
            </td>
            <td
              align="right"
              style={{
                borderBottom: "1px solid #dddddd",
                padding: "10px 0px",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  color: "#777777",
                  textTransform: "uppercase",
                  textAlign: "right",
                }}
              >
                {formatCurrency(tax.custom_tax)}
              </div>
            </td>
          </tr>
        ))}
        {preTaxes.map((tax) => (
          <tr key={tax.tax_id}>
            <td
              style={{
                borderBottom: "1px solid #dddddd",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#777777",
                  padding: "10px 0px",
                }}
              >
                {tax.custom_tax_name}{" "}
                {tax.custom_tax_percentage
                  ? ` (${Number(
                      parseFloat(tax.custom_tax_percentage).toFixed(2),
                    )}%)`
                  : ""}
              </div>
            </td>
            <td
              align="right"
              style={{
                borderBottom: "1px solid #dddddd",
                padding: "10px 0px",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  color: "#777777",
                  textTransform: "uppercase",
                  textAlign: "right",
                }}
              >
                {formatCurrency(tax.custom_tax)}
              </div>
            </td>
          </tr>
        ))}
        {showSalesTax && (
          <tr key={totalTax.tax_id}>
            <td
              style={{
                borderBottom: "1px solid #dddddd",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#777777",
                  padding: "10px 0px",
                }}
              >
                {totalTax.custom_tax_name}{" "}
                {totalTax.custom_tax_percentage
                  ? ` (${Number(
                      parseFloat(totalTax.custom_tax_percentage).toFixed(2),
                    )}%)`
                  : ""}
              </div>
            </td>
            <td
              align="right"
              style={{
                borderBottom: "1px solid #dddddd",
                padding: "10px 0px",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  color: "#777777",
                  textTransform: "uppercase",
                  textAlign: "right",
                }}
              >
                {formatCurrency(totalTax.custom_tax)}
              </div>
            </td>
          </tr>
        )}
        {postTaxes.map((tax) => (
          <tr key={tax.tax_id}>
            <td
              style={{
                borderBottom: "1px solid #dddddd",
              }}
            >
              <div
                style={{
                  fontSize: "14px",
                  color: "#777777",
                  padding: "10px 0px",
                }}
              >
                {tax.custom_tax_name}{" "}
                {tax.custom_tax_percentage
                  ? ` (${Number(
                      parseFloat(tax.custom_tax_percentage).toFixed(2),
                    )}%)`
                  : ""}
              </div>
            </td>
            <td
              align="right"
              style={{
                borderBottom: "1px solid #dddddd",
                padding: "10px 0px",
              }}
            >
              <div
                style={{
                  fontSize: "13px",
                  color: "#777777",
                  textTransform: "uppercase",
                  textAlign: "right",
                }}
              >
                {formatCurrency(tax.custom_tax)}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default AdditionalTaxes;
